export default __webpack_public_path__ + "static/media/logs_3.0fc3bb68.png";